import { render, staticRenderFns } from "./DeclaringMembers.vue?vue&type=template&id=b390a758"
import script from "./DeclaringMembers.vue?vue&type=script&lang=js"
export * from "./DeclaringMembers.vue?vue&type=script&lang=js"
import style0 from "./DeclaringMembers.vue?vue&type=style&index=0&id=b390a758&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports